import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { CustomRouteService } from 'src/app/pages/custom-route/services/custom-route.service';
import { PlannerDayStateService, PlannerViewsStateService } from '../../services';
import { TranslationService } from 'src/app/services/translation.service';
import dayjs from 'dayjs';

@Component({
  selector: 'app-route-day',
  standalone: true,
  imports: [
  ],
  templateUrl: './route-day.component.html',
  styleUrls: ['./route-day.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default
  
})
export class RouteDayComponent {
  private _translationService = inject(TranslationService);
  private _customRouteService = inject(CustomRouteService);
  private _plannerDayStateService = inject(PlannerDayStateService);
  private _plannerViewStateService = inject(PlannerViewsStateService);
  
  private _dayToShowIndex =  this._plannerDayStateService.dayToShowIndex;
  private _isEditRouteView = this._plannerViewStateService.isEditRouteView;
  private _customRouteData = this._customRouteService.customRouteData;
  
  public selectedLanguage = this._translationService.selectedLanguage;
  
  public currentDay = computed(() => {
    const dayToShowIndex = this._dayToShowIndex();
    const selectedLanguage = this.selectedLanguage();
    const customRouteData = this._customRouteData();

    if (!customRouteData?.dailyRoutes?.length) {
      return '';
    }

    const dayIndex = this._isEditRouteView() ? 0 : dayToShowIndex;
    const dayRoute = customRouteData.dailyRoutes[dayIndex];

    if (!dayRoute?.date) {
      return '';
    }

    return dayjs(dayRoute.date).locale(selectedLanguage).format('ddd D MMM');
  });
}
